module.exports = __webpack_public_path__ + "static/img/dg1_ny.ce046e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dg1_ny.jpg
// module id = +jIH
// module chunks = 1